import { Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import {
	useConfigStore,
	useFormProps,
	useFormStore,
	SvgIcon,
	useProperties
} from '@/features/form';
import { useWcagKeyboardEvents } from '@/features/conversational';
import Selectable from './Selectable';
import HandleTabIndex from './HandleTabIndex';

export default function Screenshot(
	{ block, state, setValue, setNestedValue, elementIndex, ...props },
	ref
) {
	const { actions, screenshotButtonRef, currentConversationalFocusRef } = useFormStore();
	const { webView } = useFormProps();
	const { text } = useConfigStore();
	const { conversational } = useProperties();

	const { onKeyDown } = useWcagKeyboardEvents({
		onSpaceEnter: e => {
			e.stopPropagation();
			e.preventDefault();
			actions.toggleScreenshot(true);
		}
	});

	useEffect(() => {
		if (conversational && elementIndex !== 0) {
			actions.handleConversationalFocus();
			actions.updateLastKeyPressed(null);
		}
	}, []);

	//if form is loaded in via webview just show a checkbox else show a block icon that toggles the capturing process
	return (
		<Fragment>
			{!webView && (
				<Fragment>
					<div
						class={`${state.value ? 'screen-captured' : ''}`}
						ref={currentConversationalFocusRef}
					>
						<HandleTabIndex
							ref={screenshotButtonRef}
							component="button"
							type="button"
							id={`screenshot_element_${block.id}`}
							className={`section-screenshot ${
								block.properties.bottomScreen && block.tooltip ? 'tooltip' : ''
							}`}
							onClick={e => {
								e.stopPropagation();
								actions.toggleScreenshot(true);
							}}
							onKeyDown={onKeyDown}
							aria-label={text.screenCaptureText ?? block.title ?? ''}
							{...(conversational && {
								'aria-labelledby': `block-title-${block.typeName}-${block.id}`
							})}
						>
							<SvgIcon
								icon="camera"
								alt="camera icon"
							/>
							<div className="detect-capture">
								<SvgIcon
									icon="check"
									alt={text.screenCaptureSelected}
									onClick={e => e.stopPropagation()}
								/>
							</div>
							{block.properties.bottomScreen && block.tooltip && (
								<span className="tooltip">{block.tooltip}</span>
							)}
							{block.properties.bottomScreen && block.required && (
								<span className="required-mark">*</span>
							)}
						</HandleTabIndex>
					</div>
				</Fragment>
			)}
			{webView && (
				<Fragment>
					{conversational && !state.value && (
						<Selectable
							block={{
								...block,
								typeName: 'radio',
								properties: {
									show_as_buttons: true
								}
							}}
							onChange={e => {
								setValue(e.target.checked ? window.screenToken || ' ' : '');
							}}
						>
							{text.screenshotCheckboxLabel}
						</Selectable>
					)}
					{conversational && state.value && (
						<div className="screen-captured">
							<div
								id={`screenshot_element_${block.id}`}
								className="section-screenshot"
							>
								<SvgIcon
									icon="camera"
									alt="camera icon"
								/>
								<div className="detect-capture">
									<SvgIcon
										icon="check"
										alt="screenshot selected icon"
									/>
								</div>
							</div>
						</div>
					)}
					{!conversational && (
						<Selectable
							block={{
								...block,
								typeName: 'checkbox',
								properties: {}
							}}
							onChange={e => {
								setValue(e.target.checked ? window.screenToken || ' ' : '');
							}}
							checked={state.value}
						>
							{text.screenshotCheckboxLabel}
						</Selectable>
					)}
				</Fragment>
			)}
		</Fragment>
	);
}
